import Preview from '../../Panel/Ver/PreviewSize';

export function PreviewSize({ panel, size }: { panel: any, size: string }) {
    switch (panel.type) {
        default: return <Preview key={'panel' + panel.id} panel={panel} size={size} />
    }
}